import { useMemo } from "react";
import { useOrderOption, useStore } from "../hooks";
import { StoreProductModel, CartItemModifierGroupModel } from "../models";
import { isEmpty } from "../helpers";

export const useProductPrice = (
  product: StoreProductModel,
  modifierGroups: CartItemModifierGroupModel[] = [],
  quantity: number = 1
) => {
  const { hasAdInflation } = useStore();
  const { orderOption } = useOrderOption();

  const finalPrice = useMemo(() => {
    // Product inflation
    const baseInflation = Array.isArray(product.convenience)
      ? 0
      : Number(product.convenience?.[String(orderOption.type_id)] || 0);

    // Ad inflation
    const adInflation = Array.isArray(product.convenience)
      ? 0
      : hasAdInflation ? Number(product.convenience?.["adsp"] || 0) : 0;

    const basePrice = Number(product.product_price) + baseInflation + adInflation;

    // Modifier inflation
    let modifierPrice = 0;
    if (!isEmpty(modifierGroups)) {
      modifierPrice = modifierGroups.reduce((acc, group) =>
        acc + group.modifiers.reduce((sum, mod) => {
          const storeModifier = product.modifier_group
            ?.flatMap(pg => pg.modifier) // flatten all modifier groups
            .find(sm => sm.m_id === mod.m_id);

          const modInflation = Array.isArray(storeModifier?.convenience)
            ? 0
            : Number(storeModifier?.convenience?.[String(orderOption.type_id)] || 0);

          // Ad inflation
          const adInflation = Array.isArray(storeModifier?.convenience)
            ? 0
            : hasAdInflation ? Number(storeModifier?.convenience?.["adsp"] || 0) : 0;  
            
          return sum + ((Number(mod.m_price) + modInflation + adInflation) * mod.m_qty);
        }, 0)
      , 0);
    }

    return (basePrice + modifierPrice) * quantity;
  }, [orderOption.type_id, product, modifierGroups, quantity]);

  return finalPrice;
};